export default "__VITE_ASSET__E6kjTDIE__"